/* This is generated code, don't alter */
var IfcDoorPanelOperationEnum;
(function (IfcDoorPanelOperationEnum) {
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["SWINGING"] = 0] = "SWINGING";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["DOUBLE_ACTING"] = 1] = "DOUBLE_ACTING";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["SLIDING"] = 2] = "SLIDING";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["FOLDING"] = 3] = "FOLDING";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["REVOLVING"] = 4] = "REVOLVING";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["ROLLINGUP"] = 5] = "ROLLINGUP";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["FIXEDPANEL"] = 6] = "FIXEDPANEL";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcDoorPanelOperationEnum[IfcDoorPanelOperationEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcDoorPanelOperationEnum || (IfcDoorPanelOperationEnum = {}));
const IfcDoorPanelOperationEnumCount = 9;
export { IfcDoorPanelOperationEnum, IfcDoorPanelOperationEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcDoorPanelOperationEnum = new Int32Array([2, 15, -3]);
let prefixSumAddressIfcDoorPanelOperationEnum = new Uint32Array([0, 10, 19, 28, 40, 51, 66, 78, 89, 102]);
let slotMapIfcDoorPanelOperationEnum = new Int32Array([0, 3, 2, 8, 4, 1, 6, 5, 7]);
let encodedDataIfcDoorPanelOperationEnum = (new TextEncoder()).encode(".SWINGING..FOLDING..SLIDING..NOTDEFINED..REVOLVING..DOUBLE_ACTING..FIXEDPANEL..ROLLINGUP..USERDEFINED.");
let IfcDoorPanelOperationEnumSearch = new MinimalPerfectHash(gMapIfcDoorPanelOperationEnum, prefixSumAddressIfcDoorPanelOperationEnum, slotMapIfcDoorPanelOperationEnum, encodedDataIfcDoorPanelOperationEnum);
export { IfcDoorPanelOperationEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcDoorPanelOperationEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcDoorPanelOperationEnumSearch, input, cursor, endCursor);
}
